module.exports = __webpack_public_path__ + "images/Akera.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo/Akera.png
// module id = 135
// module chunks = 0